export enum API_ENDPOINTS {
  QUIZ_EVALUATE = '/evaluate',
  QUIZ_RESULT_EMAIL = '/send-mail',
  PRE_LAUNCH_INTEREST = '/prelaunch-notify',
}
